export const getMultipleChoiceGradeDefaultValue = field => {
	return field.options.reduce((acc, option) => ({
		...acc,
		[option.id]: null
	}), {})
};

export const getDefaultValueByFieldType = type => {
	return {
		FILE: [],
		TEXT: '',
		CHECKBOX: [],
		RADIO: '',
		MULTIPLE_CHOICE_GRADE: {}
	}[type];
};

export const MAX_FILE_FIELD_LENGTH = 5;

export const getFieldName = field => {
	return `${field.type}_${field.id}`;
};

export const getFieldOptionId = (field, option) => {
	return `${field.id}_${option.id}`;
};

export const getImageFileContainerId = field => {
	return `upload-image-${field.id}`;
};
